import { CssBaseline, GlobalStyles } from '@mui/material';
import { TimeoutModal } from '@vestwell-frontend/elements';
import { NotificationsProvider, PageNotFound } from '@vestwell-frontend/ui';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Root } from '../components';
import { ConfigProvider } from '../contexts';
import {
  AccountAccessIssuePage,
  AccountLockedPage,
  AccountSetupPage,
  AuthorizationPage,
  AuthRedirectingPage,
  ForgotPasswordPage,
  LoginAndSecurityPage,
  LogoutPage,
  MfaNudgeAppSetupPage,
  MfaNudgeCompletedPage,
  MfaNudgeMethodPage,
  MfaNudgePage,
  MfaNudgePhoneSetupPage,
  MfaNudgeStartPage,
  MfaNudgeVerifyPage,
  MfaPage,
  PersonasPage,
  PlatformSelectionPage,
  ResetPasswordExpiredPage,
  ResetPasswordPage,
  SignInPage
} from '../pages';
import { routes } from './routes';

export const AppRouter = () => {
  return (
    <>
      <CssBaseline />
      <NotificationsProvider>
        <ConfigProvider>
          <GlobalStyles
            styles={theme => ({
              body: {
                backgroundColor: `${
                  theme.palette.neutral.contrastText
                } !important`
              },
              'div#root': {
                justifyContent: 'center',
                overflowY: 'auto'
              }
            })}
          />
          <BrowserRouter>
            <Routes>
              <Route element={<Root />} path=''>
                <Route element={<LogoutPage />} path={routes.LOGOUT} />
                <Route
                  element={<AccountLockedPage />}
                  path={routes.ACCOUNT_LOCKED}
                />
                <Route
                  element={<AuthorizationPage />}
                  path={routes.AUTHORIZATION}
                />
                <Route
                  element={<AccountSetupPage />}
                  path={routes.ACCOUNT_SETUP}
                />
                <Route
                  element={
                    <TimeoutModal entity='user'>
                      <LoginAndSecurityPage />
                    </TimeoutModal>
                  }
                  path={routes.LOGIN_AND_SECURITY}
                />
                <Route
                  element={
                    <TimeoutModal entity='user'>
                      <PlatformSelectionPage />
                    </TimeoutModal>
                  }
                  path={routes.PLATFORM_SELECTION}
                />
                <Route element={<MfaPage />} path={routes.MFA_VERIFICATION} />
                <Route element={<MfaNudgePage />} path={routes.MFA_NUDGE}>
                  <Route
                    element={<MfaNudgeAppSetupPage />}
                    path={`${routes.MFA_NUDGE}/app`}
                  />
                  <Route
                    element={<MfaNudgeCompletedPage />}
                    path={`${routes.MFA_NUDGE}/completed`}
                  />
                  <Route
                    element={<MfaNudgeMethodPage />}
                    path={`${routes.MFA_NUDGE}/method`}
                  />
                  <Route
                    element={<MfaNudgePhoneSetupPage />}
                    path={`${routes.MFA_NUDGE}/phone`}
                  />
                  <Route
                    element={<MfaNudgeVerifyPage />}
                    path={`${routes.MFA_NUDGE}/verify`}
                  />
                  <Route
                    element={<MfaNudgeStartPage />}
                    path={`${routes.MFA_NUDGE}`}
                  />
                </Route>
                <Route
                  element={<ForgotPasswordPage />}
                  path={routes.FORGOT_PASSWORD}
                />
                <Route
                  element={
                    <TimeoutModal entity='user'>
                      <PersonasPage />
                    </TimeoutModal>
                  }
                  path={routes.PERSONAS}
                />
                <Route
                  element={<ResetPasswordPage />}
                  path={routes.RESET_PASSWORD}
                />
                <Route
                  element={<ResetPasswordExpiredPage />}
                  path={routes.RESET_PASSWORD_EXPIRED}
                />
                <Route
                  element={<AccountAccessIssuePage />}
                  path={routes.ACCOUNT_ACCESS_ISSUE}
                />
                <Route
                  element={<AuthRedirectingPage />}
                  path={routes.AUTH_REDIRECTING_PAGE_MOBILE}
                />
                <Route element={<SignInPage />} path={routes.SIGN_IN} />
              </Route>
              <Route element={<PageNotFound />} path='*' />
            </Routes>
          </BrowserRouter>
        </ConfigProvider>
      </NotificationsProvider>
    </>
  );
};
